import moment from 'moment';
import { removeStorege } from '../db_storage';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const checkCartStorege = (DateTime: any, time = 25): boolean => {
  const diff = moment(new Date(), 'DD/MM/YYYY HH:mm:ss').diff(
    moment(new Date(DateTime), 'DD/MM/YYYY HH:mm:ss'),
  );
  const duration = moment.duration(diff);
  const minuteDifference = Math.floor(duration.asMinutes());
  if (minuteDifference >= time) {
    removeStorege('@mais/delivery/shop/request/product/cart');
    removeStorege('@mais/delivery/shop/request/product/treat');
    removeStorege('@mais/delivery/shop/request/data/cart');
    return true;
  }

  return false;
};
